/*
 * @Author: qian.tang
 * @Date: 2023-10-23 16:42:03
 * @LastEditors: Qian Tang qian@itrazotracetech.com
 * @LastEditTime: 2023-11-02 13:33:50
 * @FilePath: \itrazo-portal-dev\src\containers\Pages\AssetManagement\apis\SensorAPI.tsx
 * @Description: 
 * 
 * Copyright (c) 2023 by ${git_name_email}, All Rights Reserved. 
 */
import { ASSET_MANAGEMENT_API as AM_API } from "utilities/AdiApi";
import { logError } from '../../RelationshipManagement/utilities/functions'
import { getBizCode } from "utilities/Functions/GlobalHelperFunctions";

const SensorAPI = {
  searchSensor: async (queryConditions: string = '') => {

    try {
      const url = `${queryConditions !== '' ? `${getBizCode()}/sensors` + queryConditions : `${getBizCode()}/sensors`}`
      const res = await AM_API.get(url)
      console.log('searchAlert res', res)
      return res.data.Items
    } catch (e) {
      logError(e)
      throw e
    }

  },
  getSensorById: async (deviceID: string) => {

    try {
      const url = `${getBizCode()}/sensors?deviceID=${deviceID}`
      const res = await AM_API.get(url)
      console.log('searchAlert res', res)
      return res.data.Item.device_data
    } catch (e) {
      logError(e)
      throw e
    }

  },
  addSensor: async (payload: any) => {

    try {
      const res = await AM_API({
        method: 'POST',
        url: `${getBizCode()}/sensors`,
        data: payload
      })
      return res
    } catch (e) {
      logError(e)
      throw e
    }

  },
  updateSensor: async (payload: any) => {

    try {
      const res = await AM_API({
        method: 'PUT',
        url: `${getBizCode()}/sensors`,
        data: payload
      })
      return res
    } catch (e) {
      logError(e)
      throw e
    }

  },
  deleteSensor: async (deviceID: string) => {

    try {
      const url = `${getBizCode()}/sensors?deviceID=${deviceID}`
      const res = await AM_API.delete(url)
      return res
    } catch (e) {
      logError(e)
      throw e
    }

  }

}

export default SensorAPI